import { render } from "./tests.vue?vue&type=template&id=bb08621a"
import script from "./tests.vue?vue&type=script&lang=js"
export * from "./tests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__